// extracted by extract-css-chunks-webpack-plugin
module.exports = {"title":"title-5D5JhRqG","list_box":"list_box-1YSsT8ck","no_more":"no_more-375_NUtc","soft_ad":"soft_ad-3BmxJY-z","hard_ad":"hard_ad-2FLhdMvF"};